(() => {
  const element = document.getElementById('MilagroSentryConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
    if (window.Sentry) {
      Sentry.init({
        dsn: 'https://741fca8db299a0377c8d2fe15e3b35f3@o4511865210142720.ingest.us.sentry.io/4511898113015808',
        environment: config.environment,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: true,
            blockAllMedia: true
          })
        ],
        tracesSampleRate: config.tracesSampleRate,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        // Cut known third-party noise: aborted fetches/media on navigation,
        // permission denials, the UserWay widget, Shopify's web-pixel
        // telemetry, HubSpot, the Instafeed app, and browser extensions.
        ignoreErrors: [
          'AbortError: The operation was aborted',
          'The play() request was interrupted',
          'not allowed by the user agent',
          'Non-Error promise rejection captured with value: undefined',
          'Invalid call to runtime.sendMessage',
          'webkit.messageHandlers',
          'fetching process for the media resource was aborted',
          'Java object is gone',
          // Microsoft Outlook's SafeLinks scanner, not a real visitor.
          'Object Not Found Matching Id',
          // Shopify injects its Sign-In-With-Shop bootstrap as an inline
          // module that uses top-level await plus a dynamic import. Old
          // WebViews cannot parse it and flaky connections cannot fetch it.
          // Neither is actionable, and neither carries a filename for
          // denyUrls to match. The theme itself uses no top-level await, and
          // a future one would fail everywhere rather than hide here. Safari
          // and Firefox say "reserved identifier", older Chrome WebViews
          // (Pinterest, Facebook on Android) say "reserved word".
          'await is a reserved identifier',
          'Unexpected reserved word',
          /Failed to fetch dynamically imported module.*shopifycloud\/shop-js/,
          // Shopify's own telemetry posts (otlp-http-production, monorail)
          // failing to send, typically to Firefox tracking protection or a
          // blocker. Sentry names the host in brackets after the browser's
          // network error; there is no stack for denyUrls to match.
          /\([a-z0-9.-]*\.shopifysvc\.com\)$/
        ],
        denyUrls: [
          /api\.userway\.org/,
          /cdn\.userway\.org/,
          /\/cdn\/wpm\//,
          /\/compiled_assets\//,
          /\/storefront\/web-components\//,
          /web-pixels/,
          /cdn\.shopify\.com\/extensions\//,
          // Everything under /cdn/shopifycloud/ is Shopify platform code
          // (shop-js, perf-kit, and friends) — never ours to fix.
          /shopifycloud\//,
          /monorail-edge\.shopifysvc\.com/,
          /\/instafeed-[a-f0-9]+\.js/,
          /hs-scripts\.com/,
          /hubspot/,
          /hubapi\.com/,
          /collectedforms\.js/,
          /klaviyo\.com/,
          /shareasale\.com/,
          /chrome-extension:\/\//,
          /safari-(web-)?extension:\/\//
        ],
        // denyUrls only matches the frame the error was thrown in, so it
        // misses cases where a third party calls into theme code. These two
        // filters inspect the whole stack instead:
        //   1. Shopify's legacy ScriptTag loader (an inline "asyncLoad"
        //      snippet injected via content_for_header) is inline on every
        //      page, so it has no URL to deny — match its function name.
        //   2. Browser extensions that re-create the page's custom elements
        //      make our constructors throw; the extension frames are the
        //      callers, never the throw site.
        beforeSend: function (event) {
          try {
            var allFrames = (event.exception && event.exception.values || [])
              .reduce(function (acc, value) {
                return acc.concat((value.stacktrace && value.stacktrace.frames) || []);
              }, []);
            if (allFrames.some(function (frame) {
              var filename = frame.filename || '';
              // Safari app extensions (PayPal Honey and friends) report a
              // local bundle path rather than an extension:// URL.
              return /^(chrome|moz|safari(-web)?|ms-browser)-extension:\/\//.test(filename) ||
                /\.appex\/|\.safariextension\//.test(filename) ||
                // Meta's in-app browsers (Instagram, Facebook) inject their
                // own instrumentation under an iabjs:// scheme.
                /^iabjs:\/\//.test(filename) ||
                // Safari masks extension-injected scripts behind this scheme
                // rather than exposing their real URL. Nothing of ours is
                // ever served from it.
                /^webkit-masked-url:\/\//.test(filename);
            })) {
              return null;
            }
            // Match any asyncLoad frame, not every frame: Sentry wraps the
            // handler and other scripts appear alongside it, so the stack is
            // rarely asyncLoad alone.
            if (allFrames.some(function (frame) {
              return frame['function'] === 'asyncLoad';
            })) {
              return null;
            }
            // If none of our own code appears anywhere in the stack, the fault
            // is not ours. This catches what denyUrls cannot: Sentry wraps
            // window.fetch, so its bundle is the throwing frame for every
            // failed fetch on the page, whoever started it — Shopify's
            // telemetry, an app block, or the SDK's own replay recorder.
            // Theme assets and inline page scripts count as ours; the Sentry
            // bundle itself does not.
            if (allFrames.length && !allFrames.some(function (frame) {
              var filename = frame.filename || '';
              if (filename.indexOf('sentry.min.js') !== -1) return false;
              if (filename.indexOf('/cdn/shop/t/') !== -1) return true;
              return filename.indexOf(config.shopUrl + '/') === 0 &&
                filename.indexOf('/cdn/') === -1;
            })) {
              return null;
            }
          } catch (e) { /* never block sending on filter failure */ }
          return event;
        }
      });
    }
})();
